<template>
    <button type="button"
            @click="callBack()"
            :disabled="disabled || lockButton">
        <template v-if="lockButton">
            <fa-icon icon="fas fa-spinner fa-spin-pulse" class="fa-spin fa-fw fa-xl"></fa-icon>
        </template> {{text}}
    </button>
</template>

<script>
    export default {
        name: "LoadingButton",
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            text: {
                type: String,
                default: '',
            }
        },
        emits: ["fnCallback"],
        data() {
            return {
                lockButton: false
            };
        },
        components: {
        },
        methods: {
            callBack() {
                this.$emit("fnCallback");
            },
            setLockStatus(status) {
                this.lockButton = status;
            }
        },
        watch: {
        },
        created() { },
        computed: {
        }
    };

</script>